const DetailRow = ({
    label,
    value,
    editable = false,
    type = "text",
    options = [],
    onChange,
}) => {
    return (
        <div className="detail-row">
            <span>{label}</span>
            <span>:&nbsp;</span>

            {editable ? (
                type === "select" ? (
                    <select
                        className="detail-row-input"
                        value={value || ""}
                        onChange={(e) => onChange(e.target.value)}
                    >
                        {options.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                ) : (
                    <input
                        className="detail-row-input"
                        type={type}
                        value={value || ""}
                        onChange={(e) => onChange(e.target.value)}
                    />
                )
            ) : (
                <strong>{value || "—"}</strong>
            )}
        </div>
    );
};

export default DetailRow;
